import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/styles/element-variables.scss";
Vue.use(ElementUI);
import router from "./router";
import store from "./store";
import "./permission"; // permission control
import * as filters from "./filters"; // global filters
//全局方法
import * as utils from "./utils";
Vue.prototype.utils = utils;
// 打印插件
import Print from 'vue-print-nb'
Vue.use(Print)

// register global utility filters.
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
import "@/styles/index.scss"; // global css
import "@/styles/style.less"; // global css
Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App,
  },
});
